


















import { Component, Prop, Provide, Vue } from 'vue-property-decorator'
import TaskSummarySource from '../modules/TaskSummarySource.vue'
import TaskSummaryInProcess from '../modules/TaskSummaryInProcess.vue'
import TaskSummaryCompleted from '../modules/TaskSummaryCompleted.vue'

@Component({
  components: {
    TaskSummarySource,
    TaskSummaryInProcess,
    TaskSummaryCompleted
  }
})
export default class TaskSummary extends Vue {}
